import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { DataSetupActions, DataSetupInitProps } from './data-setup.actions';
import * as DataSetupSelectors from './data-setup.selectors';

@Injectable({ providedIn: 'root' })
export class DataSetupFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(DataSetupSelectors.getDataSetupLoaded));
  dataSetup$ = this.store.pipe(select(DataSetupSelectors.getDataSetup));

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init(props: DataSetupInitProps): void {
    this.store.dispatch(DataSetupActions.init(props));
  }
}
